module.exports = __webpack_public_path__ + "static/media/construction.e5d5aeb0.jpg";